import { Component } from '@angular/core';
import { BaseMediaPlayerDirective } from 'src/app/directives/base-media-player.directive';

@Component({
  selector: 'app-aws-audio-player',
  templateUrl: './aws-audio-player.component.html',
  styleUrls: ['./aws-audio-player.component.sass'],
})
export class AwsAudioPlayerComponent extends BaseMediaPlayerDirective {}
